<template>
  <div class="resutls-bar h-100 txt-label-primary-2">
    <div class="row f-row spot-row h-100 txt-label-primary-2">
      <div class="col col-3 results-table-headers" v-show="includeTitle">
        Buckets:
      </div>
      <div class="col" v-bind:class="[includeTitle ? 'col-9' : 'col-12']">
        <div
          class="btn-toolbar"
          role="toolbar"
          aria-label="Toolbar with button groups"
        >
          <div class="btn-group btn-group-toggle btn-block" role="group">
            &nbsp;
            <button
              v-if="isMarket"
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('spot')"
              v-bind:class="[
                pickedDateInterval === 'spot' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1D
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('1W')"
              v-bind:class="[
                pickedDateInterval === '1W' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1W
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('2W')"
              v-bind:class="[
                pickedDateInterval === '2W' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              2W
            </button>
            <button
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('1M')"
              v-bind:class="[
                pickedDateInterval === '1M' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1M
            </button>
            <button
              v-if="!isMarket"
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('1Q')"
              v-bind:class="[
                pickedDateInterval === '1Q' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1Q
            </button>
            <button
              v-if="!isMarket"
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('6M')"
              v-bind:class="[
                pickedDateInterval === '6M' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              6M
            </button>
            <button
              v-if="!isMarket"
              type="button"
              class="btn btn-candle"
              style="width: 16.667%!important; min-width: 28px!important"
              v-on:click="_pickedDateInterval('1Y')"
              v-bind:class="[
                pickedDateInterval === '1Y' ? 'active' : '',
                blue ? 'blue-btn' : ''
              ]"
            >
              1Y
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalyticsInterval",
  props: {
    blue: { required: false, type: Boolean, default: false },
    includeTitle: { required: false, type: Boolean, default: true },
    isMarket: { required: false, type: Boolean, default: false},
    pickedDateInterval: { required: true }
  },
  data() {
    return {
      // pickedDateInterval: "1M"
    };
  },
  // watch: {
  //   initPickedDateInterval() {
  //     this.pickedDateInterval = this.initPickedDateInterval;
  //   }
  // },
  methods: {
    _pickedDateInterval(interval) {
      this.$emit("eventOnChangeInterval", interval);
    }
  }
};
</script>
